export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const IS_API_ON_THE_SAME_HOST = API_URL.includes(window.location.host);
export const SALARY_CUP = Number(process.env.REACT_APP_SALARY_CUP);
export const MAX_TEAM_AMOUNT = Number(process.env.REACT_APP_MAX_TEAM_AMOUNT);
